import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { post, put } from "../../api/axios";
import endpoints from "../../api/endpoints";
import { toast, Bounce } from "react-toastify";

import logo from "../../assets/images/elevated-logo.svg";
import login from "../../assets/images/newlogin.png";
import { useDispatch } from "react-redux";
import { setLogin, setUser, toggle } from "../../store/slices/authSlice";
import { values } from "lodash";

const Login = (props) => {
  document.title = "Login | Elevated - Admin Dashboard";

  const navigate = useNavigate();
  const [apiError, setApiError] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isFocusedEmail, setIsFocusedEmail] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const savedEmail = localStorage.getItem("savedEmail");
    const savedPassword = localStorage.getItem("savedPassword");
    const remember = localStorage.getItem("rememberMe") === "true";

    if (savedEmail && savedPassword && remember) {
      validation.setValues({ email: savedEmail, password: savedPassword });
      setRememberMe(true);
    }
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Please enter your email"),
      password: Yup.string().required("Please enter your password"),
    }),
    onSubmit: async (values) => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      try {
        const response = await post(endpoints.login, {
          email: values.email,
          password: values.password,
          isAdmin: true,
        });

        if (response?.data?.success && response?.data?.token) {
          dispatch(
            setLogin({
              currentUser: response?.data?.data,
              jid: response?.data?.token,
              isAuth: true,
              loginType: "credentials",
            })
          );
          localStorage.setItem("accessToken", response.data.token);
          localStorage.setItem("userId", response.data.data.id);

          if (rememberMe) {
            localStorage.setItem("savedEmail", values.email);
            localStorage.setItem("savedPassword", values.password);
            localStorage.setItem("rememberMe", "true");
          } else {
            localStorage.removeItem("savedEmail");
            localStorage.removeItem("savedPassword");
            localStorage.removeItem("rememberMe");
          }

          if (
            response?.data?.data?.appRole == "admin" ||
            response?.data?.data?.appRole == "staff"
          ) {
            navigate("/dashboard");
          } else {
            navigate("/gymDashboard");
          }
          const fcmToke = await localStorage.getItem("fcm");
          const fcmData = await put(endpoints.fcm, { fcm: fcmToke });
          toast.success("Login Successful", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else if (response?.data?.success) {
          navigate("/verify-email", { state: { email: values.email } });
          toast.success("Login Successful, please verify your email", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else if (response?.response?.data) {
          toast.error(response?.response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } catch (error) {
        // setApiError("Incorrect Credentials. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  useEffect(() => {
    document.body.className = "authentication-bg";
    return () => {
      document.body.className = "";
    };
  }, []);

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  return (
    <>
      <div className=" account-pages">
        <Row className="d-flex align-items-center justify-content-center min-vh-100 g-0 px-3">
          <Col md="6" className="d-none d-xl-block">
            <div className="image-section">
              <img
                src={login}
                alt="Gym Equipment"
                className="object-fit-cover img-fluid w-100 rounded-5 "
                style={{ maxHeight: "96vh" }}
              />
            </div>
          </Col>
          <Col
            xs="12"
            md="6"
            className="d-flex align-items-start justify-content-center login-scroll"
          >
            <div className="">
              <Link
                to="/"
                className="mb-3 d-block auth-logo mt-4 mt-md-4 mt-lg-4"
              >
                <img
                  src={logo}
                  alt="Elevated Iron Logo"
                  className="logo logo-light"
                />
              </Link>
            </div>
            <div className="mb-0">
              <div className="login-container-responsive">
                <div className="login-form-wrapper">
                  <div className="logo text-center mb-2">
                    <img
                      src={logo}
                      height={"140px"}
                      alt="Elevated Iron Logo"
                      className="login-logo"
                    />
                  </div>
                  <h2 className="text-center mt-2 ff-sora fw-bold font-size-24 primary-black">
                    Login to Account
                  </h2>
                  <p className="text-center ff-sora font-size-16 secondary-black fw-normal">
                    Kindly enter the credentials below to get
                    <br /> access to your account.
                  </p>

                  <Form
                    onSubmit={validation.handleSubmit}
                    className="login-form mx-2 mx-xl-0"
                  >
                    <FormGroup floating>
                      <Input
                        type="email"
                        id="email"
                        placeholder="Email"
                        className={`form-control-lg rounded-pill ff-sora fw-normal font-size-16 primary-black email-input ${
                          validation.values.email || isFocusedEmail
                            ? "bg-change"
                            : "bg-light"
                        }`}
                        value={validation.values.email}
                        onChange={validation.handleChange}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                          setIsFocusedEmail(false);
                        }}
                        onFocus={() => setIsFocusedEmail(true)}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                        style={{
                          maxWidth: "548px",
                          backgroundColor:
                            validation.values.email || isFocusedEmail
                              ? "#EBF5F4"
                              : "#F5F5F5",
                          border: "none",
                        }}
                      />

                      <Label
                        for="email"
                        className="light-black font-size-16 ff-sora fw-normal"
                      >
                        Email
                      </Label>
                      {validation.touched.email && validation.errors.email && (
                        <div className="text-danger">
                          {validation.errors.email}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup floating className="position-relative">
                      {validation.values.password != "" && (
                        <span
                          className="position-absolute  end-0 top-50 translate-middle
                          "
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setIsPasswordVisible(!isPasswordVisible)
                          }
                        >
                          {console.log(
                            validation.values.password,
                            "values.password"
                          )}
                          {isPasswordVisible ? (
                            <i className="fas fa-eye p-2"></i>
                          ) : (
                            <i className="fas fa-eye-slash p-2"></i>
                          )}
                        </span>
                      )}
                      <Input
                        type={isPasswordVisible ? "text" : "password"}
                        id="password"
                        placeholder="Password"
                        className={`form-control-lg rounded-pill ff-sora fw-normal font-size-16 primary-black email-input ${
                          validation.values.password || isFocused
                            ? "bg-change"
                            : "bg-light"
                        }`}
                        value={validation.values.password}
                        onChange={validation.handleChange}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                          setIsFocused(false);
                        }}
                        onFocus={() => setIsFocused(true)}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                            ? true
                            : false
                        }
                        style={{
                          maxWidth: "548px",
                          backgroundColor:
                            validation.values.password || isFocused
                              ? "#EBF5F4"
                              : "#F5F5F5",
                          border: "none",
                        }}
                      />
                      <Label
                        for="password"
                        className="light-black font-size-16 ff-sora fw-normal"
                      >
                        Password
                      </Label>
                      {validation.touched.password &&
                        validation.errors.password && (
                          <div className="text-danger">
                            {validation.errors.password}
                          </div>
                        )}
                    </FormGroup>

                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <FormGroup check>
                        <Label
                          check
                          className="font-size-14 ff-sora fw-normal secondary-black"
                        >
                          <Input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                            style={{ border: "1px solid black" }}
                          />
                          Remember me
                        </Label>
                      </FormGroup>
                      <Link
                        to="/reset-password"
                        className="error-red font-size-14 fw-normal ff-sora"
                      >
                        Forgot Password?
                      </Link>
                    </div>

                    <Button
                      type="submit"
                      className="custom-button bg-brand-orange rounded-pill font-size-16 fw-bold ff-sora"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Logging in..." : "Login"}
                    </Button>
                  </Form>
                </div>
                <div className="mt-4  ff-sora text-center">
                  <p className="text-center pt-0 ff-sora font-size-16 fw-medium mt-0">
                    <Link to="/redeemPass" className="brand-orange">
                      Redeem your pass here.
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(Login);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
};
